import { render } from "./StartMasterPage.vue?vue&type=template&id=e98bf05e"
import script from "./StartMasterPage.vue?vue&type=script&lang=js"
export * from "./StartMasterPage.vue?vue&type=script&lang=js"

import "./StartMasterPage.vue?vue&type=style&index=0&id=e98bf05e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__